import { ShareReportSearchResultsInterface } from 'src/pages/index.type';
import { useClickAway } from '@uidotdev/usehooks';
import { useDebounce } from 'src/hooks/useDebounce';
import { useNotification } from 'src/hooks/useNotification';
import { User } from '../ReportTableManage/index.type';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react'
import useCallApi from 'src/hooks/useCallApi';

function ShareReportSearchResults({ setShowResults, searchQuery, setListOfTable, listOfTable, handleReset, reportId }: ShareReportSearchResultsInterface)
{
    const { t } = useTranslation();
    const { callApiLoading, callApi, isError, data, setData } = useCallApi()
    const { notification, contextHolder } = useNotification();
    const debouncedSearch = useDebounce(searchQuery, 500);
    const [listOfEmails, setListOfEmails] = useState([] as User[])
    const ref: any = useClickAway(() => { setShowResults(false) });

    const handleSelect = async (foundUser: User) =>
    {
        //console.log('foundUser as argument', foundUser);
        //console.log("listOfTable", listOfTable);
        let userExist = listOfTable.some((user: User) => user.userObjectId === foundUser.userObjectId)
        //console.log('userExist', userExist);
        if (userExist)
        {
            notification({ content: { name: t("t2"), message: t("reports.requestAccess.userAlreadyAdded") }, type: 'error' })
            return
        }

        //v Limit the number of users that can be added to the list to 10 to prevent excessive sharing
        if (listOfTable.length >= 10)
        {
            notification({ content: { name: t("t2"), message: t("reports.requestAccess.userLimitReached") }, type: 'error' })
            return
        }
        //v Check if the user already has access to the report by calling the API with the user's email and the reportId as parameters
        let checkUserhasAccessToReport: any = await callApi({ endpoint: "ValidateUserAccess", query: `reportId=${reportId}&email=${foundUser.email}` }); //--> API TO CALL TO GET THE LIST OF USERS
        //console.log('checkUserhasAccessToReport', checkUserhasAccessToReport);

        if (checkUserhasAccessToReport?.isError)
        {
            notification({ content: { name: t("t2"), message: t("reports.requestAccess.inActiveUser") }, type: 'error' })
            return
        }
        if (checkUserhasAccessToReport?.isValid === false)
        {
            if (checkUserhasAccessToReport?.usersWithAccess?.length > 0)
            {
                notification({ content: { name: t("t2"), message: t("reports.requestAccess.userAlreadyHasAccessToReport") }, type: 'error' })
                return
            }
            else
            {
                notification({ content: { name: t("t2"), message: t("reports.requestAccess.inActiveUser") }, type: 'error' })
                return
            }
        }

        setListOfTable([...listOfTable, foundUser])
        handleReset();
    }

    //Effect to handle search
    useEffect(() => { searchUsers(); }, [debouncedSearch]);
    //----Method to search users when debouncedSearch changes
    const searchUsers = async () =>
    {
        if (debouncedSearch === "")
        {
            setData([]);
            setListOfEmails([]);
            return;
        }
        //v call the API to search users
        //console.log('searching for users with query:', debouncedSearch)
        let extraHeaders = {
            pagesize: 50,
            pageindex: 1,
            searchFilter: debouncedSearch,
            ascending: true,
        }
        let res: any = await callApi({ endpoint: 'UserList', extraHeaders }) ///api/report/search       
        setListOfEmails(res?.data || []);
        //console.log('searching for users with query:', res)
    }
    return (
        <>
            {searchQuery !== "" && debouncedSearch !== "" && (
                <ul ref={ref} className="absolute bg-white w-full max-h-96 overflow-y-auto scroll-smooth scroll-thin  z-10 general-shadow m-0 p-0 border-l border-r border-[#dedede]">
                    {
                        callApiLoading
                            ? <li className="w-full py-3 pl-3 pr-2 cursor-pointer text-sm">{t("loading")}</li>
                            : <>
                                {
                                    data.length === 0 && searchQuery !== "" && (
                                        <li className="w-full py-3 pl-3 pr-2 cursor-pointer text-sm">{t("no_Matching_Results")}</li>
                                    )}
                                {
                                    Array.isArray(listOfEmails) && listOfEmails.map((user: User) => (
                                        <li
                                            key={user.userObjectId}
                                            className="w-full flex flex-col py-2 pl-8 pr-2 cursor-pointer hover:text-[#ed1a3b] hover:bg-[#fff2ee] text-sm"
                                            onClick={async () => await handleSelect(user)}>
                                            <span className='font-bold'>{user?.fullName}</span>
                                            <span>{user?.email || "No email"}</span>
                                        </li>
                                    ))
                                }
                            </>
                    }
                </ul>
            )}
            {contextHolder}
        </>
    )
}
export default ShareReportSearchResults